import Vue from 'vue'
import VueRouter from 'vue-router'

import AppLanding from '../components/applications/AppLanding'
import AppIFUGenerator from '../components/applications/AppIFUGenerator'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(VueRouter);

const routes = [
    {path: '', name: 'AppLanding', component: AppLanding},
    {path: '/IFU', name: 'IFU', component: AppIFUGenerator},
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
